import { handleDownloadUrlResponse } from "@newLibs/converting";
import { MvnMessage } from "@newLibs/utils";
import { notify } from "@newHooks/context/snackbar/notify";
import { useBaseMutation } from "../baseMutation";
import { COMMON_LANG } from "@maven-msg/lang/common";
import { DownloadCertificateBySignerTokenRequest, DownloadCertificateBySignerTokenResponse } from "@maven-rest/docs/DocumentSign.dto";
import { DocumentSignerUrl } from "@maven-rest/docs/DocumentSigner.url";

export function useDownloadCertificateBySignerTokenMutation(req: { pathVariable: Pick<DownloadCertificateBySignerTokenRequest, "token"> }) {
  const { token } = req.pathVariable;
  return useBaseMutation<DownloadCertificateBySignerTokenResponse, DownloadCertificateBySignerTokenRequest>({
    fnOption: {
      url: DocumentSignerUrl.downloadCertificateBySignerToken(token),
    },
    onSuccess: (data) => handleDownloadUrlResponse(data.url),
    onError: (error) => notify(MvnMessage(COMMON_LANG.ERROR, { message: error.responseMessage }), "WARN"),
  });
}
